import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {CawawiService} from '../../services/cawawi/cawawi.service';
import {Subject, takeUntil} from 'rxjs';
import {CawawiArticle, CawawiArticlePagingModel} from '../../models/cawawi/cawawi.article';
import {CurrencyPipe, NgIf} from '@angular/common';
import {
    AbstractControl,
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators
} from '@angular/forms';
import {CreateRecipeModel, RecipeModel, UpdateRecipeModel} from '../../models/recipe/recipe.model';
import {ReservedAppointmentModel} from '../../models/appointment/appointment.model';
import {RecipeService} from '../../services/recipe/recipe.service';
import {FilterArticleQuery} from '../../models/cawawi/cawawi-article-query.model';
import {PagingModel} from '../../models/paging/paging.model';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {PatientModel} from '../../models/patient/patient.model';
import {ValueModel, ValueService} from '../../services/value/value.service';
import {MatOption, MatSelect} from '@angular/material/select';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatSliderModule} from '@angular/material/slider';
import {BrowserStorageService} from '../../services/browser-storage/browser-storage.service';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {PharmacyService} from '../../services/pharmacy/pharmacy.service';
import {PharmacyModel} from '../../models/pharmacy/pharmacy.model';
import {MatInput} from '@angular/material/input';

@Component({
    selector: 'app-recipe',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatPaginator,
        CurrencyPipe,
        MatSelect,
        MatOption,
        MatCheckbox,
        MatSliderModule,
        NgIf,
        MatInput
    ],
    templateUrl: './recipe.component.html',
    styleUrl: './recipe.component.sass'
})

export class RecipeComponent implements OnInit, OnDestroy {
    @ViewChild(MatPaginator, {static: false}) paginator?: MatPaginator;
    private destroy$ = new Subject<void>();
    today: string = new Date().toLocaleDateString('de-DE')
    filterTimeout: any;
    // Test with form
    recipeForm: FormGroup = new FormGroup({
        selectedArticles: new FormArray([]),
        articles: new FormArray([])
    });
    filterControl = new FormControl('');
    appointmentData!: ReservedAppointmentModel;
    cawawiArticles: CawawiArticle[] = [];
    selectedArticles: CawawiArticle[] = [];
    recipe!: CreateRecipeModel;
    isFollowUpRecipe: boolean = false;
    articleFilterQuery: FilterArticleQuery = {
        page: 1,
        perPage: 10,
        filter: '',
        orderBy: 'articleNumber',
        order: 'ASC',
        onlyAvailable: true,
        detailed: true,
        thcMin: null,
        thcMax: null,
        cbdMin: null,
        cbdMax: null,
        priceMin: null,
        priceMax: null,
        characteristics: null,
        characteristicsAllTogether: null,
        conditions: null,
        conditionsAllTogether: null,
        supplier: null
    }
    actualPaging!: PagingModel;
    isUpdate: boolean = false
    patient!: PatientModel

    loadedRecipe!: UpdateRecipeModel

    drugDosages: ValueModel[] = []
    drugProcessings: ValueModel[] = []

    patientId: string = '';
    showOnlyAvailableArticles: boolean = true

    cbdMin: number = 0;
    cbdMax: number = 30;
    thcMin: number = 0;
    thcMax: number = 30;
    priceMin: number = 0;
    priceMax: number = 30;

    pharmacyForm = new FormGroup({
        id: new FormControl(''),
        isRegularPharmacy: new FormControl(false),
    });

    customPharmacyForm = new FormGroup({
        name: new FormControl('', Validators.required),
        street: new FormControl('', Validators.required),
        houseNumber: new FormControl('', Validators.required),
        zipCode: new FormControl('', Validators.required),
        city: new FormControl('', Validators.required),
        phoneNumber: new FormControl('', Validators.required),
    });

    pharmacyList: PharmacyModel[] = [];
    selectedPharmacy: PharmacyModel | null = null;

    constructor(
        private router: Router,
        private cawawiService: CawawiService,
        private recipeService: RecipeService,
        private fb: FormBuilder,
        private valueService: ValueService,
        private infoMessageService: InfoMessageService,
        private browserStorageService: BrowserStorageService,
        private pharmacyService: PharmacyService
    ) {
        const navigation = this.router.currentNavigation();
        let appointment = navigation?.extras?.state?.['appointment'];
        const recipe = navigation?.extras?.state?.['recipe'];
        let patient = navigation?.extras?.state?.['patient'];
        const isUpdate = navigation?.extras?.state?.['isUpdate'];

        if (appointment) {
            this.browserStorageService.set('selectedAppointment', appointment);
        } else if (this.browserStorageService.hasObject('selectedAppointment')) {
            appointment = JSON.parse(this.browserStorageService.get('selectedAppointment')!);
        }

        if (patient) {
            this.browserStorageService.set('selectedPatient', patient);
        } else if (this.browserStorageService.hasObject('selectedPatient')) {
            patient = JSON.parse(this.browserStorageService.get('selectedPatient')!);
        }

        if (appointment) {
            this.appointmentData = appointment
            this.patientId = this.appointmentData.patient.id;

        }
        if (recipe) {
            this.compareRecipe(recipe)
            this.selectedArticles = recipe.positions;
            this.isFollowUpRecipe = true
        }

        if (patient) {
            this.patient = patient
            this.patientId = this.patient.id;
        }
        if (isUpdate) {
            this.isUpdate = isUpdate
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.getCawawiArticles(false, true);
        this.getDosages();
        this.getProcessing();
        this.getPharmacyList();
    }

    changeAvailableState(): void {
        this.articleFilterQuery.onlyAvailable = this.showOnlyAvailableArticles;
        this.articleFilterQuery.page = 1;
        this.getCawawiArticles(true);
    }

    onCbdChange(): void {
        this.articleFilterQuery.cbdMin = this.cbdMin;
        this.articleFilterQuery.cbdMax = this.cbdMax;
        this.articleFilterQuery.page = 1;
        this.applyFilter(true);
    }

    onThcChange(): void {
        this.articleFilterQuery.thcMin = this.thcMin;
        this.articleFilterQuery.thcMax = this.thcMax;
        this.articleFilterQuery.page = 1;
        this.applyFilter(true);
    }

    onPriceChange(): void {
        this.articleFilterQuery.priceMin = this.priceMin;
        this.articleFilterQuery.priceMax = this.priceMax;
        this.articleFilterQuery.page = 1;
        this.applyFilter(true);
    }

    applyFilter(force: boolean = false): void {
        if (!force && this.filterControl.value === this.articleFilterQuery.filter) {
            return;
        }

        clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
            if (this.filterControl.value !== this.articleFilterQuery.filter) {
                this.articleFilterQuery.filter = this.filterControl.value || '';
                this.articleFilterQuery.page = 1;
            }
            this.getCawawiArticles(true);
        }, 500)
    }

    updateSelectedArticles(ctrl: AbstractControl): void {
        const selectedArticlesArray = this.selectedArticlesFormArray;
        const articleNumber = ctrl.get('articleNumber')?.value;
        const quantityToAdd = ctrl.get('quantityToAdd')?.value;

        // Check if this article is already in the selectedArticles array.
        const index = selectedArticlesArray.controls.findIndex(group =>
            group.get('articleNumber')?.value === articleNumber
        );

        if (index !== -1) {
            // Update the entry: if the quantity is set to 0, remove it.
            if (quantityToAdd === 0 || quantityToAdd === null) {
                selectedArticlesArray.removeAt(index);
                ctrl.get('inRecipe')?.patchValue(false);
            } else {
                selectedArticlesArray.at(index).patchValue({
                    quantity: quantityToAdd,
                    quantityToAdd: quantityToAdd,
                    inRecipe: true
                });
            }
        } else {
            // Limit to 3 articles for the prescription preview
            if (selectedArticlesArray.length >= 3) {
                this.infoMessageService.createMessage('Ein Rezept kann maximal 3 Artikel enthalten.', 'info');
                return;
            }

            // Only add if a positive quantity is provided.
            if (quantityToAdd > 0) {
                const articleGroup = this.fb.group({
                    articleNumber: [ctrl.get('articleNumber')?.value],
                    articleName: [ctrl.get('articleName')?.value],
                    nettoPrice: [ctrl.get('nettoPrice')?.value],
                    bindingSize: [ctrl.get('bindingSize')?.value],
                    quantityToAdd: [quantityToAdd],
                    quantity: [quantityToAdd],
                    variantName: [ctrl.get('variantName')?.value],
                    unitOfMeasurement: [ctrl.get('unitOfMeasurement')?.value],
                    inRecipe: [true],
                    drugDosage: [ctrl.get('drugDosage')?.value || ''],
                    customDrugDosage: [ctrl.get('customDrugDosage')?.value || ''],
                    drugProcessing: [ctrl.get('drugProcessing')?.value || ''],
                    customDrugProcessing: [ctrl.get('customDrugProcessing')?.value || ''],
                    characteristics: [ctrl.get('characteristics')?.value]
                });
                selectedArticlesArray.push(articleGroup);
                // Mark the current control as being in the recipe.
                ctrl.get('inRecipe')?.patchValue(true);
            }
        }
    }

    removeSelectedArticle(index: number, articleControl: AbstractControl): void {
        this.selectedArticlesFormArray.removeAt(index);
        // Find the article in the main list and reset its inRecipe state
        const articleInList = this.articlesFormArray.controls.find(ctrl =>
            ctrl.get('articleNumber')?.value === articleControl.get('articleNumber')?.value
        );
        if (articleInList) {
            articleInList.get('inRecipe')?.patchValue(false);
            articleInList.get('quantityToAdd')?.patchValue(0);
        }
    }


    createRecipe(): void {
        let appointmentId: string | null = null;
        if (this.appointmentData) {
            appointmentId = this.appointmentData.id
        } else {
            appointmentId = null;
        }

        this.setPharmacy();

        this.recipe = {
            patientId: this.patientId,
            appointmentId: appointmentId,
            articles: this.selectedArticlesFormArray.getRawValue(),
            pharmacy: this.selectedPharmacy
        }

        if (this.recipe.articles.length === 0) {
            this.infoMessageService.createMessage('Es muss mindestens ein Artikel ausgewählt sein');
            return
        }
        this.recipeCreate();
    }

    updateRecipe(): void {
        this.setPharmacy();
        this.loadedRecipe.articles = this.selectedArticlesFormArray.getRawValue();
        this.loadedRecipe.pharmacy = this.selectedPharmacy;

        if (this.loadedRecipe.articles.length === 0) {
            this.infoMessageService.createMessage('Es muss mindestens ein Artikel ausgewählt sein');
            return
        }
        this.recipeUpdate();
    }

    private setPharmacy(): void {
        if (this.pharmacyForm.get('id')?.value === 'none') {
            this.selectedPharmacy = null;
        } else if (this.pharmacyForm.get('id')?.value === 'custom') {
            this.selectedPharmacy = {
                name: this.customPharmacyForm.get('name')?.value!,
                address: {
                    street: this.customPharmacyForm.get('street')?.value!,
                    houseNumber: this.customPharmacyForm.get('houseNumber')?.value!,
                    zipCode: this.customPharmacyForm.get('zipCode')?.value!,
                    city: this.customPharmacyForm.get('city')?.value!,
                },
                phoneNumber: this.customPharmacyForm.get('phoneNumber')?.value!,
                isDefault: false,
                email: '',
                noSalesTaxes: false
            };
        } else if (this.pharmacyForm.get('id')?.value !== '') {
            const found = this.pharmacyList.find(p => p.id === this.pharmacyForm.get('id')?.value);
            if (found) {
                this.selectedPharmacy = found;
            }
        }
    }

    onPageChange(event: PageEvent): void {
        if (event.pageIndex === this.actualPaging.totalPages - 1) {
            this.articleFilterQuery.page = this.actualPaging.totalPages;
            this.articleFilterQuery.perPage = event.pageSize;
            this.getCawawiArticles(true)
            return;
        }
        if (event.pageIndex === 0) {
            this.articleFilterQuery.page = 1;
            this.articleFilterQuery.perPage = event.pageSize;
            this.getCawawiArticles(true)
            return;
        }
        if (event.previousPageIndex! > event.pageIndex) {
            this.articleFilterQuery.page = this.actualPaging.pageNumber - 1;
            this.articleFilterQuery.perPage = event.pageSize;
            this.getCawawiArticles(true)
            return;
        }
        if (event.previousPageIndex! < event.pageIndex) {
            this.articleFilterQuery.page = this.actualPaging.pageNumber + 1;
            this.articleFilterQuery.perPage = event.pageSize;
            this.getCawawiArticles(true)
            return;
        }

        if (event.pageSize !== this.actualPaging.pageSize) {
            this.articleFilterQuery.page = event.pageIndex + 1;
            this.articleFilterQuery.perPage = event.pageSize;
            this.getCawawiArticles(true)
            return;
        }
    }

    private getCawawiArticles(pageChange: boolean = false, initialLoad: boolean = false): void {

        this.cawawiService.postGetCawawiArticle(this.articleFilterQuery)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<CawawiArticlePagingModel>) => {
                    this.cawawiArticles = [...response.data.articles];
                    this.actualPaging = response.data.paging;
                    this.buildForm(initialLoad);
                    if (pageChange) {
                        this.compareArticles();
                    } else
                    if (this.isFollowUpRecipe || this.isUpdate) {
                        this.compareArticles();
                    }
                },
                error: (error) => {
                }
            })
    }

    private recipeCreate(): void {
        this.recipeService.createRecipe(this.recipe)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.infoMessageService.createMessage('Rezept erfolgreich erstellt!');
                    // this.browserStorageService.remove('selectedAppointment');
                    // this.browserStorageService.remove('selectedPatient');
                    this.router.navigate(['patientenakte'], {
                        state: {
                            patient: this.patient || this.appointmentData?.patient,
                            appointment: this.appointmentData
                        }
                    })
                },
                error: (error) => {
                }
            })
    }

    private recipeUpdate(): void {
        this.recipeService.updateRecipe(this.loadedRecipe.id, this.loadedRecipe)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.infoMessageService.createMessage('Rezept erfolgreich aktualisiert!');
                    this.router.navigate(['patientenakte'], {
                        state: {
                            patient: this.patient,
                            appointment: this.appointmentData
                        }
                    })
                },
                error: (error) => {
                }
            })
    }


    private compareArticles(): void {
        this.selectedArticlesFormArray.controls.forEach(selectedArticle => {
            const index = this.articlesFormArray.controls.findIndex(control =>
                control.value.articleNumber === selectedArticle.value.articleNumber
            );

            if (index !== -1) {
                this.articlesFormArray.removeAt(index);
            }
        });
    }


    // TEST with form
    private buildForm(initialLoad: boolean): void {
        if (this.loadedRecipe && initialLoad) {
            this.articlesFormArray.controls = this.cawawiArticles.map(article => this.createArticleGroup(article))
            this.selectedArticlesFormArray.controls = this.loadedRecipe.articles.map(article => this.createSelectedArticleGroup(article))
        } else {
            this.articlesFormArray.controls = this.cawawiArticles.map(article => this.createArticleGroup(article))
        }
    }

    private createArticleGroup(article: CawawiArticle): FormGroup {
        return this.fb.group({
            articleNumber: [article.articleNumber],
            articleName: [article.articleName],
            nettoPrice: [article.nettoPrice],
            bindingSize: [article.bindingSize],
            quantity: [article.quantity],
            variantName: [article.variantName],
            quantityToAdd: [0, [Validators.required]],
            unitOfMeasurement: [article.unitOfMeasurement || {
                id: '2655033c-fe82-4589-9444-ad3d4148088d',
                name: 'Gramm',
                shortName: 'g'
            }],
            inRecipe: [article.inRecipe],
            characteristics: [article.characteristics],
            conditions: [article.conditions],
            genetic: [article.genetic],
            thc: [article.thc],
            cbd: [article.cbd],
            drugDosage: [article.drugDosage || ''],
            customDrugDosage: [article.customDrugDosage || ''],
            drugProcessing: [article.drugProcessing || ''],
            customDrugProcessing: [article.customDrugProcessing || '']
        });
    }

    private createSelectedArticleGroup(article: any): FormGroup {
        return this.fb.group({
            articleNumber: [article.articleNumber],
            articleName: [article.articleName],
            nettoPrice: [article.nettoPrice],
            bindingSize: [article.bindingSize],
            quantity: [article.quantity],
            variantName: [article.variantName],
            quantityToAdd: [article.quantity || article.quantityToAdd, [Validators.required]],
            unitOfMeasurement: [article.unitOfMeasurement || {
                id: '2655033c-fe82-4589-9444-ad3d4148088d',
                name: 'Gramm',
                shortName: 'g'
            }],
            inRecipe: [article.inRecipe],
            characteristics: [article.characteristics],
            conditions: [article.conditions],
            genetic: [article.genetic],
            thc: [article.thc],
            cbd: [article.cbd],
            drugDosage: [article.drugDosage || ''],
            customDrugDosage: [article.customDrugDosage || ''],
            drugProcessing: [article.drugProcessing || ''],
            customDrugProcessing: [article.customDrugProcessing || '']
        });
    }

    private compareRecipe(recipe: RecipeModel): void {
        this.loadedRecipe = {
            articles: recipe.positions,
            id: recipe.id
        }
    }

    private getDosages(): void {
        this.valueService.getDosages()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.drugDosages = response.data;
                },
                error: (error) => {
                }
            })
    }

    private getProcessing(): void {
        this.valueService.getProcessing()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.drugProcessings = response.data;
                },

                error: (error) => {
                }
            })
    }

    getPharmacyList(): void {
        this.pharmacyService.getPharmacies()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<PharmacyModel>) => {
                    this.pharmacyList = response.data;
                    if (this.patient?.regularPharmacy && this.patient?.regularPharmacy?.id) {

                        if (this.patient?.regularPharmacy.id === '00000000-0000-0000-0000-000000000000') {
                            this.pharmacyForm.get('id')?.patchValue('custom');
                            this.customPharmacyForm.patchValue(this.patient?.regularPharmacy!.address);
                            this.customPharmacyForm.get('name')?.patchValue(this.patient!.regularPharmacy!.name);
                            this.customPharmacyForm.get('phoneNumber')?.patchValue(this.patient!.regularPharmacy!.phoneNumber);
                        } else {
                            this.pharmacyForm.get('id')?.patchValue(this.patient?.regularPharmacy.id);
                            this.compareRegularPharmacy();
                        }
                        this.pharmacyForm.get('isRegularPharmacy')?.patchValue(true);
                    }
                },
                error: (error) => {
                    console.error('Error fetching pharmacy list:', error);
                }
            });
    }

    checkDisabledState(): void {
        if (this.pharmacyForm.get('id')?.value !== 'custom') {
            this.customPharmacyForm.disable();
            this.compareRegularPharmacy();
        } else {
            this.customPharmacyForm.reset();
            this.customPharmacyForm.enable();
        }
    }

    compareRegularPharmacy(): void {
        const found = this.pharmacyList.find(pharmacy => pharmacy.id === this.pharmacyForm.get('id')?.value);
        if (found) {
            this.customPharmacyForm.patchValue(found.address);
            this.customPharmacyForm.get('name')?.patchValue(found.name);
            this.customPharmacyForm.disable();
        }
    }

    getTotalPrice(): number {
        let total = 0;
        this.selectedArticlesFormArray.controls.forEach(article => {
            total += article.value.nettoPrice * article.value.quantityToAdd;
        });
        return total;
    }

    get articlesFormArray(): FormArray {
        return this.recipeForm.get('articles') as FormArray;
    }

    get selectedArticlesFormArray(): FormArray {
        return this.recipeForm.get('selectedArticles') as FormArray;
    }

}
